import ConfigService from '@/services/ConfigService'

export function createBeforeEach ({ checkAuth, store }) {
  return async function beforeEach (to, from, next) {
    if (to.path === '/403' || to.path === '/error') {
      return next()
    }
    try {
      await checkAuth(store, ConfigService.reauthorizeUrl())
    } catch (err) {
      return next(false)
    }
    next()
  }
}
